import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const UndoButton = ({
  onClick
}) => {
  return /*#__PURE__*/_jsx(Button, {
    onClick: onClick,
    use: "link-on-bright",
    paddingInlineStart: "600",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.alerts.undo-button"
    })
  });
};
UndoButton.displayName = 'UndoButton';
UndoButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
export default UndoButton;